<template>
  <h3 class="mb-5">Recently used codes</h3>
  <p class="mb-5">This table shows the most recently used voucher codes</p>
  <SoAlert v-if="referrals.error" title="Failed to fetch recent referrals" />
  <SoDataTable
    v-else
    ref="referrals-table"
    :loading="referrals.isFetching"
    :headers="referralsTableHeaders"
    :items="referralsTableItems"
    :has-pagination="referralsTableItems.length > 10"
    searchable
    data-testid="recent-referrals-table"
    row-clickable
    @click:row="viewCode"
  />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { ReferralService } from "@/services/operations/ReferralService"
  import SoDataTable from "@/components/dataTable/SoDataTable.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import {
    SoDataTableColumnType,
    SoDataTableHeader,
    SoDataTableItem,
  } from "@/types/components/SoDataTable"
  import { RouteNames } from "@/types/router"

  const MAX_RESULT_COUNT = 25
  const referralsTableHeaders: SoDataTableHeader[] = [
    {
      title: "Code",
      key: "code",
    },
    {
      title: "Referrer",
      key: "referrerAccountNumber",
    },
    {
      title: "Date used",
      key: "referredDate",
      type: SoDataTableColumnType.DATE_TIME,
    },
    {
      title: "Email",
      key: "email",
    },
  ]

  export default defineComponent({
    components: {
      SoAlert,
      SoDataTable,
    },
    data() {
      return {
        referralsTableHeaders,
        referrals: ReferralService.getRecentReferrals(MAX_RESULT_COUNT),
      }
    },
    computed: {
      referralsTableItems() {
        return this.referrals.data.map((codeObj) => ({
          ...codeObj,
        }))
      },
    },
    methods: {
      viewCode(referral: SoDataTableItem) {
        this.$router.push({
          name: RouteNames.AdminReferralCode,
          params: { referralCode: referral.code as string },
        })
      },
    },
  })
</script>
